import type { CoverSheetConfigCard } from '../../types';

export const leadSourceCard = {
  id: 'sellerSideContacts.leadSource',
  innerTitle: 'Lead Source',
  fields: {
    leadSourceId: {
      name: 'leadSourceId',
      entity: 'interaction',
      type: 'leadSource',
      label: 'Lead Source',
      options: [],
      placeholderText: 'Search or select',
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
      ],
      customField: {
        name: 'leadSourceNameSpecified',
        label: 'Please Specify',
        placeholderText: 'Please Specify',
      },
    },
  },
} satisfies CoverSheetConfigCard;
